import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { PromoPerformanceComponent } from './performance/promo-performance.component';
import { PromoValueComponent } from './value/promo-value.component';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { SearchToolbarModelFactoryService } from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection } from '../../../../models/search-toolbar-factory-parameters.model';

@Component({
    selector: 'app-promo-customer',
    templateUrl: './promo-customer.component.html',
    styleUrls: ['./promo-customer.component.css']
})
//Pagina 53 - Pagina 54
export class PromoCustomerComponent implements OnInit {
    multi: any;
    @ViewChild(PromoPerformanceComponent) customerPerformance: PromoPerformanceComponent;
    @ViewChild(PromoValueComponent) customerValue: PromoValueComponent;
    public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
    oldData: any;

    items: MenuItem[];
    activeIndex: number;
    translations: any = {};

    constructor(private translate: TranslateService,
                private svcAnalytics: AnalyticsService,
                private searchModelFactory: SearchToolbarModelFactoryService) {

        this.translate.get([
            'promo.analysis',
            'promo.clientiSingolaPromo'
        ]).subscribe((t) => {
            this.translations = {
                page_title: t['promo.clientiSingolaPromo']
            };
        });
    }

    ngOnInit() {
        this.activeIndex = 0;
        this.items = [];

        this.translate.get([
            "promo.customerPerformance",
            "promo.customerValue"
        ]).subscribe(t => {
            const searchParams: SearchToolbarFactoryParameters = new SearchToolbarFactoryParameters();
            searchParams.svcAnalytics = this.svcAnalytics;
            searchParams.dateFunctionType = SearchToolbarDateFunction.VaDates;
            searchParams.finestra = SearchToolbarFilterWindow.FiftyThree;
            searchParams.raggruppamento = SearchToolbarFilterGrouping.None;
            searchParams.disabledSections = [SearchToolbarSection.CardModes];

            this.searchModelFactory.buildSearchToolbarModel(searchParams).subscribe((model) => {
                this.searchModel = model;
            });


            this.items.push(
                {
                    label: t['promo.customerPerformance'],
                    command: (event: any) => {
                        this.activeIndex = 0;
                    }
                },
                {
                    label: t['promo.customerValue'],
                    command: (event: any) => {
                        this.activeIndex = 1;
                    }
                }
            );
        });
    }

    ApplyResult (data) {
        const isDataEquals = JSON.stringify(this.oldData) === JSON.stringify(data);

        switch (this.activeIndex) {
            case 0:
                if (!isDataEquals) {
                    this.customerValue.resetData();
                }
                this.customerPerformance.searchValue(data);
                break;
            case 1:
                if (!isDataEquals) {
                    this.customerPerformance.resetData();
                }

                this.customerValue.searchValue(data);
                break;
        }

        this.oldData = { ...data };
    }

}



// WEBPACK FOOTER //
// ./src/app/views/analytics/promo/customer/promo-customer.component.ts